<div style="position: relative;">
  <div #mailTo class="filter-bttn tags-sec" (click)="toInput.focus()">
    @for (tag of emailTags.tags; track tag) {
      <div class="tag" [class.highlighted]="tag?.highlighted" [title]="tag.email">
        @if (tag?.firstName || tag?.lastName) {
          <div>{{tag?.firstName}} {{tag?.lastName}}</div>
        }
        @if (!tag?.firstName && !tag?.lastName) {
          <div>{{tag.email}}</div>
        }
        <div class="hover-bttn" (click)="emailTags.deleteTag(tag)">
          <ion-icon name="fa-x-mark"></ion-icon>
        </div>
      </div>
    }
    <input #toInput type="email" placeholder="E-Mail-Adressen..."
      (focus)="emailTags.focus()"
      (blur)="blur()"
      [(ngModel)]="emailTags.searchText"
      (keydown)="emailTags.keyenterPressed($event)"
      (keydown.escape)="toInput.blur()">

  </div>

  <div [ngStyle]="{'top.px': mailTo.getClientRects().item(0)?.height + 20}" ArrowKeyUseable [arrowKeysOptions]="emailTags.arrowKeysOptions"  >
    @if (emailTags.focused) {
      <div class="email-select-box">
        @if (emailTags.emailAdresses.length == 0) {
          <div class="no-content" style="margin: 15px 0; font-size: 14px;">
            Keine Email-Adressen
          </div>
        }
        @for (item of emailTags.emailAdresses; track item; let i = $index) {
          <ion-item (click)="itemClicked(item)" (mouseenter)="emailTags.arrowKeysOptions.mouseOverItem.next(i)" (mousemove)="emailTags.arrowKeysOptions.mouseMove.next(true)">
            <ion-label>{{item?.firstName}} {{item?.lastName}} ({{item.email}})</ion-label>
          </ion-item>
        }
      </div>
    }
  </div>

</div>